<template>
  <div>
    <div class="ElasticResourceIp-title">
      <div>{{ $t("RAM.ALI.ElasticIP.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticResourceIp:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:elasticResourceIp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="ElasticResourceIp-top">
      <elastic-resource-search
        ref="elasticResourceSearchChild"
      ></elastic-resource-search>
    </div>
    <table-elastic-resource></table-elastic-resource>
  </div>
</template>

<script>
import ElasticResourceSearch from "../eip/ElasticResourceSearch";
import TableElasticResource from "../eip/TableElasticResource";

export default {
  name: "ElasticResourceIp",
  components: {
    ElasticResourceSearch,
    TableElasticResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.elasticResourceSearchChild.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 8,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.elasticResourceSearchChild.accountNameSearchKey;
      this.companyId = this.$refs.elasticResourceSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliEip({
          accountName: this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "弹性公网IP.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.ElasticResourceIp-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.ElasticResourceIp-title > div:nth-child(1) {
  float: left;
}
.ElasticResourceIp-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.ElasticResourceIp-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/eip/ElasticResourceIp.vue